import { defineMessages } from 'react-intl'

export const rejectMessages = defineMessages({
  cancel_success_title: { id: 'towingRecord.cancel.success.notification.title', defaultMessage: 'Success' },
  cancel_success_message: { id: 'towingRecord.cancel.success.notification.message', defaultMessage: 'Success' },
  cancel_error_title: { id: 'towingRecord.cancel.error.notification.title', defaultMessage: 'Error' },
  cancel_error_message: { id: 'towingRecord.cancel.error.notification.message', defaultMessage: 'Error' },
  invalid_value_title: { id: 'containers.graphql.invalid_param.title', defaultMessage: 'Error' },
  invalid_value_message: { id: 'containers.graphql.invalid_param.message', defaultMessage: 'Invalid value' },

  cancel_header: { id: 'towingOrder.rejectOrder.cancelHeader', defaultMessage: 'Peru työ' },
  reject_header: { id: 'towingOrder.rejectOrder.rejectHeader', defaultMessage: 'Hylkää työ' },
  cancel_reason_label: { id: 'towingOrder.rejectOrder.cancelReasonLabel', defaultMessage: 'Peruutuksen syy' },
  reject_reason_label: { id: 'towingOrder.rejectOrder.rejectReasonLabel', defaultMessage: 'Hylkäämisen syy' },
  cancel_sos_warning: {
    id: 'towingOrder.rejectOrder.cancelSosWarning',
    defaultMessage: 'HUOM! Työ poistetaan järjestelmästä.',
  },
  save_button: { id: 'towingOrder.rejectOrder.saveButton', defaultMessage: 'Tallenna' },
})
